const initializeRydeScrollLift = (scope = document) => {
  const roots = [
    ...(scope.matches?.('[data-scroll-lift]') ? [scope] : []),
    ...scope.querySelectorAll('[data-scroll-lift]')
  ];

  for (const root of roots) {
    if (root.dataset.scrollLiftReady === 'true') continue;

    const distance = Number.parseFloat(root.dataset.scrollLiftDistance) || 160;
    const targetSelector = root.dataset.scrollLiftTarget;
    const minWidth = Number.parseFloat(root.dataset.scrollLiftMinWidth) || 1280;
    const controller = new AbortController();
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const widthQuery = window.matchMedia(`(min-width: ${minWidth}px)`);
    let frame = 0;

    const update = () => {
      frame = 0;
      if (motionQuery.matches || !widthQuery.matches) {
        root.style.setProperty('--scroll-lift', '0px');
        return;
      }

      const rect = root.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
      if (targetSelector) {
        const target = root.querySelector(targetSelector);
        if (!target) return;

        const currentLift = Number.parseFloat(root.style.getPropertyValue('--scroll-lift')) || 0;
        const targetRect = target.getBoundingClientRect();
        const baseCenter = targetRect.top - rect.top + targetRect.height / 2 - currentLift;
        const centeredProgress = Math.min(1, progress * 2);
        const targetCenter = rect.height * (1 - centeredProgress / 2);
        const lift = targetCenter - baseCenter;
        root.style.setProperty('--scroll-lift', `${Math.round(lift)}px`);
        return;
      }

      root.style.setProperty('--scroll-lift', `${Math.round(progress * -distance)}px`);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    root.dataset.scrollLiftReady = 'true';
    window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
    motionQuery.addEventListener('change', schedule, { signal: controller.signal });
    widthQuery.addEventListener('change', schedule, { signal: controller.signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      controller.abort();
      if (frame) cancelAnimationFrame(frame);
    }, { signal: controller.signal });
    schedule();
  }
};

initializeRydeScrollLift();
document.addEventListener('shopify:section:load', (event) => initializeRydeScrollLift(event.target));
